import { api } from 'shared';
import { z } from 'zod';

export const PlacesBlockResponseSchema = z.object({
    data: z.object({
        image: z.object({
            url: z.string(),
        }).optional().nullable(),
        places: z.array(
            z.object({
                documentId: z.string(),
                slug: z.string(),
                name: z.string(),
                images: z.array(
                    z.object({
                        url: z.string(),
                    }),
                ).optional().nullable(),
            }),
        ).optional().nullable(),
    }),
});
export const fetchPlacesBlock = async () => (
    api.get<z.infer<typeof PlacesBlockResponseSchema>>(
        '/places-block',
        {
            populate: {
                image: {
                    fields: 'url',
                },
                places: {
                    populate: {
                        images: {
                            fields: 'url',
                        },
                    },
                },
            },
        },
        PlacesBlockResponseSchema,
    )
);
